import { configureStore } from "@reduxjs/toolkit";
// settings
import settings from "../features/settings/Slice";

// auth
import auth from "../features/auth/Slice";

// common
import common from "../features/admin/common/Slice";

// masters
import masters from "./masters";

// masters
import company from "./company";

// Customer
import customer from "./customer";

// customization
import customization from "./customization";

// Dashboard
import dashboard from "./dashboard";

// ChnageStatus
import chnage_stock from "./chnage_stock";

// All trade
import all_trade from "./all_trade";

// All Wallet History
import all_wallet_history from "./all_wallet_history";

// Notice
import notice from "./notice";

export const store = configureStore({
  reducer: {
    // settings
    settings: settings,
    //auth
    auth: auth,
    //common
    common: common,
    //masters
    masters,
    //company
    company,
    //Customer
    customer,
    //customization
    customization,
    // dashboard
    dashboard,
    // chnage_stock
    chnage_stock,
    // all_trade
    all_trade,
    // all_wallet_history
    all_wallet_history,
    // notice,
    notice,
  },
});
